import styles from "../../../styles/Components/new-dashboard/AccountSummary.module.css";
import { Skeleton, Tooltip } from "antd";
import DashboardContentBox from "../DashboardContentBox";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { TbAlertTriangle } from "react-icons/tb";
import { MdLock, MdSettings } from "react-icons/md";
import useServiceStatus from "../../../hooks/useServiceStatus";
import ServiceActivationModal from "../../../shared/service-activation/ServiceActivationModal";
import { useNavigate } from "react-router-dom";
import ChartIcon from "../../../ui/icons/ChartIcon";
import { FaCircleCheck } from "react-icons/fa6";

export const ServiceInfo = ({
  title,
  status,
  alertMsg,
  icon = {},
  style = {},
}) => {
  return (
    <div className={styles.info} style={style}>
      <span>
        {Object.keys(icon)?.length > 0 && icon} {title}
      </span>
      {status && (
        <Tooltip title={alertMsg} color={"red"}>
          <TbAlertTriangle size={15} className={styles.warnIcon} />
        </Tooltip>
      )}
    </div>
  );
};

function ServiceItem({ serviceName, isActive }) {
  return (
    <div
      className={`${styles.service} ${isActive ? styles.activeService : styles.inactiveService}`}
    >
      <span>{serviceName}</span>
      {isActive ? <FaCircleCheck size={11} /> : <MdLock />}
    </div>
  );
}

function ActiveServices() {
  const {
    profile: { loading },
  } = useSelector((state) => state);

  const { isActive: isInsightActive } = useServiceStatus("insight");
  const { isActive: isSimulatorActive } = useServiceStatus("tradeSimulator");
  const { isActive: isBotActive } = useServiceStatus("bot");
  const { isActive: isAiSignalActive } = useServiceStatus("aiAssistant");
  const { isActive: isAlertActive } = useServiceStatus("alert");
  const noActiveService =
    !isBotActive &&
    !isInsightActive &&
    !isAiSignalActive &&
    !isAlertActive &&
    !isSimulatorActive;

  const totalServiceCount = 5;
  const activeServiceCount =
    Number(isBotActive) +
    Number(isInsightActive) +
    Number(isAiSignalActive) +
    Number(isAlertActive) +
    Number(isSimulatorActive);
  const [showActivationModal, setShowActivationModal] = useState(false);

  const navigate = useNavigate();

  return (
    <DashboardContentBox
      className={styles.box}
      onClick={() => navigate("/pricing-billing/activate-services")}
    >
      <span
        className={styles.inviteBtn}
        onClick={(e) => {
          e.stopPropagation();
          setShowActivationModal(true);
        }}
      >
        <MdSettings size={16} />
      </span>

      <span className={styles.boxIcon}>
        <ChartIcon />
        {/*<AiOutlineLineChart />*/}
      </span>
      <h5>
        Active Services{" "}
        <span className={styles.servicesCounter}>
          {activeServiceCount} of {totalServiceCount}
        </span>
      </h5>
      {loading ? (
        <Skeleton.Input active />
      ) : (
        <div className={styles.infoList}>
          {noActiveService ? (
            <div className={styles.info} style={{ flexDirection: "column" }}>
              <span>No individual services active.</span>
              <span
                className={styles.addBtn}
                style={{ lineHeight: 1.5 }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowActivationModal(true);
                }}
              >
                Activate Services
              </span>
            </div>
          ) : (
            <div className={styles.services}>
              <ServiceItem isActive={isAiSignalActive} serviceName="AI" />
              <ServiceItem isActive={isBotActive} serviceName="Bot" />
              <ServiceItem isActive={isInsightActive} serviceName="Insights" />
              <ServiceItem isActive={isAlertActive} serviceName="Alert" />
              <ServiceItem
                isActive={isSimulatorActive}
                serviceName="Trade Simulator"
              />
            </div>
            // <>
            //   {isAiSignalActive && (
            //     <ServiceInfo
            //       title="AI"
            //       // status={showAlertForPro}
            //       // alertMsg={proAlert}
            //       icon={<FaSignal color="#0C4CFC" />}
            //     />
            //   )}
            //   {isBotActive && (
            //     <ServiceInfo
            //       title={"Bot"}
            //       // status={showAlertForBasic}
            //       // alertMsg={basicAlert}
            //       icon={<FaRobot color="#0C4CFC" />}
            //     />
            //   )}
            //   {isSimulatorActive && (
            //     <ServiceInfo
            //       title="Trade Sim"
            //       icon={<MdTrendingUp color="#0C4CFC" />}
            //     />
            //   )}
            //   {isInsightActive && (
            //     <ServiceInfo
            //       title="Insights"
            //       icon={<AiOutlineBarChart color="#0C4CFC" />}
            //     />
            //   )}
            //   {isAlertActive && (
            //     <ServiceInfo
            //       title="Alert"
            //       icon={<HiMiniBellAlert color="#0C4CFC" />}
            //     />
            //   )}
            // </>
          )}
        </div>
      )}

      {showActivationModal && (
        <div onClick={(e) => e.stopPropagation()}>
          <ServiceActivationModal
            show={showActivationModal}
            setShow={setShowActivationModal}
          />
        </div>
      )}
    </DashboardContentBox>
  );
}

export default ActiveServices;
